// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_lottie-web_build_player_lottie_js":"c1fa4334b0efad58","src_app_pages_dashboards_dashboards_module_ts":"a82b925bfab73327"}[chunkId] + ".js";
};